const isDisposed = player => {
  return !player || (typeof player.isDisposed === 'function' && player.isDisposed())
}

const seekPlayerToHighlight = (player, highlight) => {
  if (isDisposed(player) || !highlight) {
    return false
  }

  const start = Number(highlight.start)
  if (!Number.isFinite(start)) {
    return false
  }

  const seek = () => {
    if (isDisposed(player)) {
      return
    }

    const current = Number(player.currentTime())
    if (!Number.isFinite(current) || Math.abs(current - start) > 0.05) {
      player.currentTime(start)
    }
  }

  if (typeof player.readyState === 'function' && player.readyState() >= 1) {
    seek()
  } else if (typeof player.one === 'function') {
    player.one('loadedmetadata', seek)
  } else {
    return false
  }

  return true
}

const focusPlayerForShortcuts = player => {
  if (isDisposed(player)) return
  const element = player.el?.()
  if (!element) return
  element.setAttribute('tabindex', '-1')
  element.focus({ preventScroll: true })
}

export {
  focusPlayerForShortcuts,
  seekPlayerToHighlight
}
